import type { NoContainerResolverContext } from '@source-components-react/types';
import { resolveEmbed } from './resolve-embed';

/**
 * The iframe carries the className — when there is one. A rejected or unset
 * URL renders nothing, and a class handed to a component that renders nothing
 * disappears without trace, so this answers from the same resolution the
 * component uses.
 */
export const resolveRendersOwnElement = ({
  componentAttributes,
}: NoContainerResolverContext): boolean => resolveEmbed(componentAttributes) !== null;
